import { date, object, string } from 'yup';
import dayjs from 'dayjs';

import {
  DATE_IN_PAST,
  DATE_AFTER_DNR_DATE,
  REQUIRED_FIELD,
  DATE_AFTER_CONTRACT_END_PLUS_1
} from '@/config/text.const';

export const validationSchema = object().shape({
  statusChangeComment: string()
    .max(100, 'Must be maximum ${max} characters')
    .required(REQUIRED_FIELD),

  statusChangeDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), DATE_IN_PAST)
    .required('You must enter a date')
    .test((value, { options, createError }) => {
      const contractEndDate = dayjs(options?.context?.contract?.contractEndDate ?? null)?.add(1, 'day');
      const contractRenewableTerm = options?.context?.contract?.renewableTerm ?? null;

      const selectedDate = dayjs(value ?? null);
      if (!contractRenewableTerm && selectedDate.isAfter(contractEndDate, 'date')) {
        return createError({
          message: DATE_AFTER_CONTRACT_END_PLUS_1
        });
      }
      return true;
    }),

  noFurtherBillingDate: date()
    .test((value, { createError }) => {
      const selectedDate = dayjs(value ?? null);

      if (selectedDate.isBefore(dayjs(), 'date')) {
        return createError({
          message: DATE_IN_PAST
        });
      }

      return true;
    })
    .test((value, { options, createError }) => {
      const contractEndDate = dayjs(options?.context?.contract?.contractEndDate ?? null);
      const selectedDate = dayjs(value ?? null);
      const contractRenewableTerm = options?.context?.contract?.renewableTerm ?? null;

      if (!contractRenewableTerm && selectedDate.isAfter(contractEndDate, 'date')) {
        return createError({
          message: DATE_AFTER_CONTRACT_END_PLUS_1
        });
      }

      return true;
    })
    .test((value, { parent, createError }) => {
      if (!parent?.statusChangeDate) {
        return true;
      }
      const selectedDate = dayjs(value ?? null);
      const dnrDate = dayjs(parent.statusChangeDate);

      if (selectedDate.isAfter(dnrDate, 'date')) {
        return createError({
          message: DATE_AFTER_DNR_DATE
        });
      }

      return true;
    })
    .nullable()
    .notRequired()
});
